/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initilaState = {
  selectedClient: 'PQM',
  invoiceNumber: '',
  reqRecordMailingData: {
    freezeInvoiceBy: 'PQM',
    rebateProgramCode: '',
    planType: '',
    allManufacturers: true,
    quarter: null,
    mfgIdList: null,
    // userId: localStorage.getItem('logInUser'),
    runProcedure: '',
    freezeDate: new Date(),
    invoiceNum: '',
  },
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_CLIENT': {
      return { ...state, selectedClient: action.payload };
    }
    case 'SET_INVOICE_NUMBER': {
      return { ...state, invoiceNumber: action.payload };
    }

    case actionTypes.SET_REQ_RECORD_MAILING_DATA: {
      return { ...state, reqRecordMailingData: action.payload };
    }
    case actionTypes.GET_MANUFACTURERS_BY_PQR: {
      return { ...state, manufacturersByPQR: action.payload };
    }
    case actionTypes.INVOICE_FREEZE_RES: {
      return { ...state, freezeInvoiceRes: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrFreezeInv: action.defaultQtrFreezeInv };
    }
    case actionTypes.RESET_FREEZEINVOICE_STORE_FREEZE_INV: {
      return { ...initilaState };
    }
    case actionTypes.SET_ERROR_MSG: {
      return { ...state, errorMsgsStore: action.errorMsgsStore };
    }

    default:
      return state;
  }
};

export default reducer;
